"use strict";

const _ = require("lodash");
const { draftify, compileProperties, compileRows } = require("../compiler");

const PROPERTIES = {
  NOTE: ["value", "status"]
};

const DRAFT_PATHS = ["notes.*"];

const OMIT = ["draft", "diff", "created", "updated", "author"];

const compileNote = ({ current, proposed, context: data }) => {
  if (current && !current.draft) {
    if (
      current.author?.id &&
      data.user?.id &&
      current.author.id !== data.user.id
    ) {
      return { row: current };
    }
    const { author, created, updated } = _.cloneDeep(current);
    const { id } = proposed;
    const initial = {
      id,
      author,
      created,
      updated
    };
    const note = compileProperties({
      properties: PROPERTIES.NOTE,
      before: current,
      after: proposed,
      initial
    });
    const row = _.pickBy(note, _.identity);
    return { row, draft: !_.isEmpty(note.diff) };
  }
  const note = draftify({
    object: proposed,
    path: "notes.*",
    paths: DRAFT_PATHS,
    omit: OMIT
  });
  const row = _.pickBy(note, _.identity);
  return { row, draft: true };
};

const compileData = ({ currentData, proposedData }) => {
  const { templates, statuses, user } = currentData;
  const data = { templates, statuses, user };
  const { rows: notes, draft } = compileRows({
    current: currentData.notes,
    proposed: proposedData.notes,
    compileRow: compileNote,
    context: data
  });
  data.notes = !_.isEmpty(notes) && notes;
  if (draft) {
    data.draft = true;
  }
  return _.pickBy(data, _.identity);
};

const compile = ({ current, proposed }) => {
  const currentData = current?.data;
  const proposedData = proposed?.data;
  const data =
    (proposedData &&
      compileData({
        currentData,
        proposedData
      })) ||
    _.cloneDeep(currentData);
  return { data };
};

module.exports = {
  compile
};
